module.exports = __webpack_public_path__ + "static/media/hot_kjgw.f88e9d63.png";